import { GET_EXPENSES, ADD_EXPENSE/*, DELETE_EXPENSE*/ } from 'redux/actionTypes';

export default function expenses(state = [], action) {
    switch(action.type) {
        case GET_EXPENSES:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_EXPENSE:
            return [
                action.payload,
                ...state
            ];
        /*case DELETE_EXPENSE:
            return [
                ...state.filter(expense => expense.id !== action.payload)
            ];*/
        default:
            return state;
    }
};